/* INR-konfigurator (V12) – tillval kan vara förvalda (default_checked), t.ex. Push Tipmatic för Core Solid.
   V10: – huvudbilden växlar till INR:s kombinationsbild för vald kommod + tvättställ.
   V9: – visuell: storlek, kulörprover, bildkort och förhandsvisning.
   Bygger på V8 – additiv komponent, samma principer som Vedum V7.
   Kommod + tvättställ/bänkskiva (+ obligatoriskt Soak till Flow) + frivilliga tillval läggs i varukorgen
   som separata, verkliga Shopify-varianter i ett anrop. Duschdörrar: dörr A + dörr B som separata rader.
   Variant-id och pris hämtas live; datasnippeten anger bara kompatibilitet. */
(function () {
  if (customElements.get('inr-configurator')) return;

  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
    return new Intl.NumberFormat('sv-SE', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format((cents || 0) / 100);
  };
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const uid = () => 'inr-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  const normSku = (s) => String(s || '').replace(/^'+/, '').trim();   // butikens SKU:er kan börja med apostrof
  const imgw = (src, w) => src ? `${src}${String(src).includes('?') ? '&' : '?'}width=${w}` : '';
  const vimg = (v) => (v && v.featured_image && (v.featured_image.src || v.featured_image)) || null;
  const colorOf = (v) => String((v && v.option1) || '').split(',')[0].trim();
  const NCS_RE = /^NCS\s*S?\s*\d{4}-[A-Z0-9]{1,6}$/i;

  class InrConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this.init().catch((e) => { console.warn('[INR] konfiguratorn inaktiv:', e); this.deactivate(); });
    }

    async init() {
      const all = JSON.parse(this.querySelector('[data-inr-config]').textContent);
      this.cfg = (all.products || {})[this.dataset.handle];
      if (!this.cfg) return this.deactivate();
      this.parent = JSON.parse(this.querySelector('[data-inr-parent]').textContent);
      this.form = document.getElementById(this.dataset.formId);
      this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      this.state = { group: null, attrs: {}, req: null, addons: {}, ncs: '', doorB: '' };
      ((this.cfg.steps || []).find((x) => x.id === 'addons') || { items: [] }).items.forEach((a) => { if (a.default_checked) this.state.addons[a.product_handle] = true; });

      if (this.cfg.mode === 'furniture') {
        this.basinStep = this.cfg.steps.find((s) => s.id === 'basin');
        this.addonStep = this.cfg.steps.find((s) => s.id === 'addons');
        await this.loadComponents();
        if (!this.groups.length) return this.deactivate();
      } else if (this.cfg.mode !== 'door_pair') return this.deactivate();

      this.hideDefaultForm();
      this.picker = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"], variant-radios[data-section="${this.dataset.sectionId}"]`);
      if (this.cfg.mode === 'furniture' && this.picker && (this.parent.option_names || []).length === 1) this.picker.hidden = true;  // kulörrutorna ersätter rullistan
      this.hidden = false;
      this.bind();
      const want = new URLSearchParams(window.location.search).get(this.cfg.color_param || 'inr_farg');
      if (want) { const v = this.parent.variants.find((x) => colorOf(x) === want); if (v && v.id !== this.parentVariant().id) this.selectParent(v); }
      this.render();
    }

    deactivate() { this.hidden = true; if (this._pf) this._pf.hidden = false; if (this.picker) this.picker.hidden = false; }

    selectParent(v) {
      // Styr temats egen variantväljare så att pris, URL och galleri uppdateras som vanligt.
      const sel = this.picker && this.picker.querySelector('select');
      if (sel && [...sel.options].some((o) => o.value === v.option1)) { sel.value = v.option1; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      const radio = this.picker && [...this.picker.querySelectorAll('input[type="radio"]')].find((r) => r.value === v.option1);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); return; }
      if (this.idInput) { this.idInput.value = v.id; this.idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    async fetchProducts(handles) {
      const root = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      const out = {};
      await Promise.all([...new Set(handles)].map(async (h) => {
        try {
          const r = await fetch(`${root}products/${h}.js`, { headers: { Accept: 'application/json' } });
          if (r.ok) out[h] = await r.json();
        } catch (e) { /* komponenten visas inte */ }
      }));
      return out;
    }

    resolveOption(o) {
      const p = this.products[o.product_handle];
      const v = p && p.variants.find((x) => normSku(x.sku) === normSku(o.sku));
      if (!v || !v.available) return null;
      const img = (v.featured_image && v.featured_image.src) || p.featured_image || null;
      return { ...o, variant: v, product: p, image: img };
    }

    async loadComponents() {
      const handles = [];
      this.basinStep.groups.forEach((g) => { g.options.forEach((o) => handles.push(o.product_handle)); if (g.requires) g.requires.options.forEach((o) => handles.push(o.product_handle)); });
      (this.addonStep ? this.addonStep.items : []).forEach((a) => handles.push(a.product_handle));
      this.products = await this.fetchProducts(handles);
      this.groups = this.basinStep.groups.map((g) => {
        const options = g.options.map((o) => this.resolveOption(o)).filter(Boolean);
        let requires = null;
        if (g.requires) {
          const ro = g.requires.options.map((o) => this.resolveOption(o)).filter(Boolean);
          if (!ro.length) return null;            // obligatoriskt tillbehör saknas → gruppen visas inte
          requires = { ...g.requires, options: ro };
        }
        return options.length ? { ...g, options, requires } : null;
      }).filter(Boolean);
      this.addons = (this.addonStep ? this.addonStep.items : []).map((a) => {
        const r = this.resolveOption(a);
        return r ? { ...r, label: a.label, info: a.info } : null;
      }).filter(Boolean);
    }

    hideDefaultForm() {
      this._pf = this.parentElement ? this.parentElement.querySelector(':scope > product-form') : null;
      if (this._pf) this._pf.hidden = true;
    }

    bind() {
      if (this.idInput) this.idInput.addEventListener('change', () => this.render());
      document.addEventListener('change', (e) => {
        const t = e.target;
        if (t.closest && t.closest(`[data-section="${this.dataset.sectionId}"]`)) setTimeout(() => this.render(), 60);
        else if (t.name === 'quantity' && t.getAttribute('form') === this.dataset.formId) this.renderSummary();
      });
      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.name === 'inr-color') { const v = this.parent.variants.find((x) => String(x.id) === t.value); if (v) this.selectParent(v); return; }
        if (t.name === 'inr-group') { this.state.group = t.value; this.state.attrs = {}; this.state.req = null; }
        else if (t.dataset.attr) this.state.attrs[t.dataset.attr] = t.value;
        else if (t.name === 'inr-req') this.state.req = t.value;
        else if (t.dataset.addon) this.state.addons[t.dataset.addon] = t.checked;
        else if (t.name === 'inr-door-b') this.state.doorB = t.value;
        else return;
        this.render();
      });
      this.addEventListener('input', (e) => {
        if (e.target.name === 'inr-ncs') { this.state.ncs = e.target.value; this.renderSummary(); }
      });
      this.querySelector('[data-inr-cta]').addEventListener('click', () => this.addToCart());
    }

    parentVariant() {
      const id = this.idInput ? Number(this.idInput.value) : null;
      return this.parent.variants.find((v) => v.id === id) || this.parent.variants[0];
    }
    isNcs(pv) { return !!this.cfg.ncs && /^NCS\b/i.test(String(pv.option1 || '')); }
    currentGroup() { return (this.groups || []).find((g) => g.key === this.state.group) || null; }

    attrValues(group, attrId) {
      const vals = [];
      group.options.forEach((o) => { if (o.attrs[attrId] && !vals.includes(o.attrs[attrId])) vals.push(o.attrs[attrId]); });
      return vals;
    }

    /* Returnerar { lines: [{variant, product, qty, label, detail, props}], missing } */
    resolve() {
      const pv = this.parentVariant();
      const qty = this.quantity();
      const lines = [];
      const missing = [];
      if (this.cfg.mode === 'door_pair') {
        lines.push({ variant: pv, product: { title: this.parent.title }, qty, detail: pv.title, props: { Dörr: 'A' } });
        const b = this.doorOptions(pv).find((v) => String(v.id) === this.state.doorB);
        if (b) lines.push({ variant: b, product: { title: this.parent.title }, qty, detail: b.title, props: { Dörr: 'B' } });
        return { lines, missing };
      }
      const pprops = {};
      if (this.isNcs(pv)) {
        if (!NCS_RE.test(this.state.ncs.trim())) missing.push('Ange NCS-kod (t.ex. NCS S 2005-Y20R)');
        else pprops['NCS-kod'] = this.state.ncs.trim().toUpperCase();
      }
      lines.push({ variant: pv, product: { title: this.parent.title }, qty, detail: pv.title, props: pprops });
      const g = this.currentGroup();
      if (!g) missing.push(this.basinStep.label);
      else {
        let opt = null;
        const attrIds = (this.basinStep.attributes || []).map((a) => a.id).filter((id) => this.attrValues(g, id).length);
        if (!attrIds.length) opt = g.options[0];
        else {
          const chosen = {};
          attrIds.forEach((id) => { const vals = this.attrValues(g, id); chosen[id] = vals.length === 1 ? vals[0] : this.state.attrs[id]; });
          opt = g.options.find((o) => attrIds.every((id) => o.attrs[id] === chosen[id])) || null;
          if (!opt) missing.push('Välj ' + this.basinStep.attributes.find((a) => a.id === attrIds[0]).label.toLowerCase());
        }
        if (opt) lines.push({ variant: opt.variant, product: opt.product, qty, detail: Object.values(opt.attrs).join(' · ') });
        if (g.requires) {
          const r = g.requires.options.length === 1 ? g.requires.options[0] : g.requires.options.find((o) => o.sku === this.state.req);
          if (!r) missing.push('Välj tvättställ Soak');
          else lines.push({ variant: r.variant, product: r.product, qty: qty * (g.requires.quantity || 1), detail: Object.values(r.attrs).join(' · ') });
        }
      }
      (this.addons || []).forEach((a) => { if (this.state.addons[a.product_handle]) lines.push({ variant: a.variant, product: a.product, qty, detail: 'Tillval' }); });
      return { lines, missing };
    }

    doorOptions(pv) {
      const sizeIdx = (this.parent.option_names || []).indexOf(this.cfg.size_option || 'Mått');
      return this.parent.variants.filter((v) => v.available && v.options.every((o, i) => i === sizeIdx || o === pv.options[i]));
    }

    render() {
      if (this.cfg.mode === 'furniture') this.applyCombo();
      const steps = this.querySelector('[data-inr-steps]');
      const sid = this.dataset.sectionId;
      const pv = this.parentVariant();
      let html = '';
      if (this.cfg.mode === 'door_pair') {
        const sizeIdx = (this.parent.option_names || []).indexOf(this.cfg.size_option || 'Mått');
        const opts = this.doorOptions(pv);
        if (!opts.find((v) => String(v.id) === this.state.doorB)) this.state.doorB = '';
        html += `<p class="inr-configurator__info">${esc(this.cfg.info || '')}</p>`;
        html += `<fieldset class="js product-form__input vedum-configurator__step"><legend class="form__label">Dörr A<span class="inr-configurator__tag">Vald ovan</span></legend><p>${esc(pv.options[sizeIdx])}</p></fieldset>`;
        html += `<label class="inr-configurator__field vedum-configurator__step">Dörr B – samma glas och profil<select name="inr-door-b"><option value="">Endast en dörr</option>${opts.map((v) => `<option value="${v.id}" ${String(v.id) === this.state.doorB ? 'selected' : ''}>${esc(v.options[sizeIdx])} – ${money(v.price)}</option>`).join('')}</select></label>`;
      } else {
        const tag = (t) => `<span class="inr-configurator__tag">${t}</span>`;
        if ((this.cfg.siblings || []).length) {
          const cur = colorOf(pv);
          html += `<div class="vedum-configurator__step"><p class="form__label">Bredd (cm)</p><div class="inr-configurator__sizes">${this.cfg.siblings.map((sb) => sb.handle === this.dataset.handle
            ? `<span class="inr-configurator__size is-active" aria-current="true">${esc(sb.label)}</span>`
            : `<a class="inr-configurator__size" href="${esc((this.dataset.rootUrl || '/').replace(/\/?$/, '/'))}products/${esc(sb.handle)}?${esc(this.cfg.color_param || 'inr_farg')}=${encodeURIComponent(cur)}">${esc(sb.label)}</a>`).join('')}</div></div>`;
        }
        const colors = [];
        this.parent.variants.forEach((v) => { if (!colors.find((c) => colorOf(c) === colorOf(v))) colors.push(v); });
        if (colors.length > 1) {
          html += `<fieldset class="vedum-configurator__step inr-configurator__swatches"><legend class="form__label">Kulör: <strong>${esc(colorOf(pv))}</strong></legend>`;
          colors.forEach((v) => {
            const id = `ic-${sid}-c-${v.id}`; const im = vimg(v);
            html += `<input type="radio" class="visually-hidden" id="${id}" name="inr-color" value="${v.id}" ${colorOf(v) === colorOf(pv) ? 'checked' : ''} ${v.available ? '' : 'disabled'}>
              <label for="${id}" class="inr-configurator__swatch" title="${esc(colorOf(v))}">${im ? `<img src="${esc(imgw(im, 160))}" alt="" loading="lazy" width="56" height="56">` : `<span class="inr-configurator__swatch-blank"></span>`}<span>${esc(colorOf(v))}</span></label>`;
          });
          html += '</fieldset>';
        }
        if (this.isNcs(pv)) {
          html += `<label class="inr-configurator__field vedum-configurator__step">NCS-kod${tag('Obligatoriskt')}<input type="text" name="inr-ncs" value="${esc(this.state.ncs)}" placeholder="NCS S 2005-Y20R" autocomplete="off"><small class="inr-configurator__info">NCS har längre leveranstid, 30–32 arbetsdagar enligt INR.</small></label>`;
        }
        const g = this.currentGroup();
        html += `<fieldset class="js product-form__input vedum-configurator__step"><legend class="form__label">${esc(this.basinStep.label)}${tag('Obligatoriskt')}</legend>`;
        this.groups.forEach((grp) => {
          const base = Math.min(...grp.options.map((o) => o.variant.price));
          const extra = grp.requires ? Math.min(...grp.requires.options.map((o) => o.variant.price)) * (grp.requires.quantity || 1) : 0;
          const id = `ic-${sid}-${grp.key}`;
          const im = grp.options[0].image;
          const thumb = im ? `<img class="vedum-configurator__thumb" src="${esc(imgw(im, 160))}" alt="" loading="lazy" width="80" height="80">` : '<span class="vedum-configurator__thumb"></span>';
          const multi = grp.options.length > 1 || (grp.requires && grp.requires.options.length > 1);
          html += `<input type="radio" id="${id}" name="inr-group" value="${esc(grp.key)}" ${this.state.group === grp.key ? 'checked' : ''}>
            <label for="${id}" class="vedum-configurator__choice">${thumb}<span class="vedum-configurator__choice-text"><span class="vedum-configurator__choice-name">${esc(grp.label)}</span>${grp.detail ? `<span class="vedum-configurator__choice-detail">${esc(grp.detail)}</span>` : ''}<span class="vedum-configurator__choice-price">${multi ? 'från ' : ''}${money(base + extra)}</span></span></label>`;
        });
        html += '</fieldset>';
        if (g) {
          const chips = (name, items, checkedFn, labelFn, dataAttr) => items.map((o, i) => {
            const id = `ic-${sid}-${name}-${i}`;
            return `<input type="radio" class="visually-hidden" id="${id}" name="${name}" ${dataAttr(o)} ${checkedFn(o) ? 'checked' : ''}><label for="${id}" class="inr-configurator__swatch inr-configurator__swatch--wide">${o.image ? `<img src="${esc(imgw(o.image, 200))}" alt="" loading="lazy" width="72" height="72">` : '<span class="inr-configurator__swatch-blank"></span>'}<span>${esc(labelFn(o))}<br><small>${money(o.variant.price)}</small></span></label>`;
          }).join('');
          (this.basinStep.attributes || []).forEach((a) => {
            const vals = this.attrValues(g, a.id);
            if (vals.length < 2) return;
            const opts = vals.map((v) => g.options.find((o) => o.attrs[a.id] === v));
            html += `<fieldset class="vedum-configurator__step inr-configurator__swatches"><legend class="form__label">${esc(a.label)}${this.state.attrs[a.id] ? `: <strong>${esc(this.state.attrs[a.id])}</strong>` : ''}</legend>`;
            html += chips(`inr-${a.id}`, opts, (o) => this.state.attrs[a.id] === o.attrs[a.id], (o) => o.attrs[a.id], (o) => `data-attr="${esc(a.id)}" value="${esc(o.attrs[a.id])}"`);
            html += '</fieldset>';
          });
          if (g.requires && g.requires.options.length > 1) {
            const cur = g.requires.options.find((o) => o.sku === this.state.req);
            html += `<fieldset class="vedum-configurator__step inr-configurator__swatches"><legend class="form__label">${esc(g.requires.label)}${cur ? `: <strong>${esc(Object.values(cur.attrs).join(' '))}</strong>` : ''}${tag('Obligatoriskt')}</legend>`;
            html += chips('inr-req', g.requires.options, (o) => this.state.req === o.sku, (o) => Object.values(o.attrs).join(' '), (o) => `value="${esc(o.sku)}"`);
            html += '</fieldset>';
          }
          html += this.previewHtml(g);
        }
        if ((this.addons || []).length) {
          html += `<fieldset class="vedum-configurator__step"><legend class="form__label">${esc(this.addonStep.label)}${tag('Frivilligt')}</legend>`;
          this.addons.forEach((a) => {
            html += `<label class="inr-configurator__addon">${a.image ? `<img src="${esc(imgw(a.image, 160))}" alt="" loading="lazy" width="64" height="64">` : ''}<span class="inr-configurator__addon-text"><span>${esc(a.label)} – ${money(a.variant.price)}</span>${a.info ? `<small>${esc(a.info)}</small>` : ''}</span><input type="checkbox" data-addon="${esc(a.product_handle)}" ${this.state.addons[a.product_handle] ? 'checked' : ''}></label>`;
          });
          html += '</fieldset>';
        }
      }
      const focused = document.activeElement && document.activeElement.name === 'inr-ncs';
      steps.innerHTML = html;
      if (focused) { const f = steps.querySelector('[name="inr-ncs"]'); if (f) { f.focus(); f.setSelectionRange(f.value.length, f.value.length); } }
      this.renderSummary();
    }

    previewHtml(g) {
      // Visuell förhandsvisning av vald yta (som ROOH): bänkskiva/tvättställ + ev. Soak.
      const { lines } = this.resolve();
      const parts = lines.slice(1).filter((l) => l.detail !== 'Tillval').map((l) => ({ l, im: vimg(l.variant) || (l.product && l.product.featured_image) }));
      if (!parts.length) return '';
      return `<figure class="vedum-configurator__step inr-configurator__preview">${parts.map((p) => p.im ? `<img src="${esc(imgw(p.im, 600))}" alt="${esc(p.l.product.title)}" loading="lazy">` : '').join('')}<figcaption>${this.comboUrl ? '<strong>Huvudbilden visar din kombination.</strong><br>' : ''}${parts.map((p) => esc(p.l.product.title.split(' – ')[0] + (p.l.detail && p.l.detail !== 'Default Title' ? ' – ' + p.l.detail : ''))).join(' + ')}<br><span class="caption">Bild: INR</span></figcaption></figure>`;
    }

    comboKey() {
      const g = this.currentGroup();
      if (!g) return null;
      if (g.requires) {
        const opt = g.options.length === 1 ? g.options[0] : g.options.find((o) => o.attrs.kulor === this.state.attrs.kulor);
        const req = g.requires.options.length === 1 ? g.requires.options[0] : g.requires.options.find((o) => o.sku === this.state.req);
        return opt && req ? `flow:${opt.attrs.kulor}:${normSku(req.sku)}` : null;
      }
      return g.options.length === 1 ? normSku(g.options[0].sku) : null;
    }

    applyCombo() {
      // Byter bilden i den aktiva bilden i temats galleri – endast vid exakt artikelmatchning, annars originalbilden.
      const pv = this.parentVariant();
      const map = (this.cfg.combo_images || {})[normSku(pv.sku)] || {};
      const key = this.comboKey();
      const url = key ? map[key] : null;
      if (this._swap) {
        const { img, src, srcset, alt } = this._swap;
        if (img.isConnected) { img.src = src; if (srcset) img.setAttribute('srcset', srcset); img.alt = alt; img.removeAttribute('data-inr-combo'); }
        this._swap = null;
      }
      this.comboUrl = url || null;
      if (!url) return;
      const gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
      if (!gallery) return;
      const fm = pv.featured_media && pv.featured_media.id;
      const slide = (fm && gallery.querySelector(`[data-media-id="${this.dataset.sectionId}-${fm}"]`)) || gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item');
      const img = slide && slide.querySelector('img');
      if (!img) return;
      this._swap = { img, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt };
      img.removeAttribute('srcset');
      img.src = `${url}?width=1400&format=jpg&quality=90`;
      img.alt = `${this.parent.title} – ${colorOf(pv)} med valt tvättställ. Bild: INR`;
      img.setAttribute('data-inr-combo', key);
    }

    renderSummary() {
      this.applyCombo();
      const pv = this.parentVariant();
      const { lines, missing } = this.resolve();
      this.querySelector('[data-inr-lines]').innerHTML = lines.map((l) =>
        `<li class="vedum-configurator__line"><span>${l.qty > 1 ? `${l.qty} × ` : ''}${esc(l.product.title)}${l.detail && l.detail !== 'Default Title' ? `<br><span class="caption">${esc(l.detail)}</span>` : ''}<br><span class="caption">Art.nr ${esc(normSku(l.variant.sku))}</span></span><span>${l.variant.compare_at_price > l.variant.price ? `<s class="inr-configurator__was">${money(l.variant.compare_at_price * l.qty)}</s><br>` : ''}${money(l.variant.price * l.qty)}</span></li>`).join('');
      const tot = lines.reduce((s, l) => s + l.variant.price * l.qty, 0);
      const was = lines.reduce((s, l) => s + Math.max(l.variant.compare_at_price || 0, l.variant.price) * l.qty, 0);
      this.querySelector('[data-inr-total]').innerHTML = (was > tot ? `<s class="inr-configurator__was">${money(was)}</s> ` : '') + esc(money(tot));
      this.querySelector('[data-inr-summary]').hidden = false;
      const hint = this.querySelector('[data-inr-hint]');
      hint.textContent = !pv.available ? 'Vald variant är tillfälligt slut – välj en annan kombination.' : (missing.length ? `${missing[0]} för att slutföra din lösning.` : '');
      this.querySelector('[data-inr-cta]').disabled = !!missing.length || !pv.available || this._busy;
    }

    quantity() {
      const q = document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`);
      const n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    async addToCart() {
      const { lines, missing } = this.resolve();
      if (missing.length || this._busy) return;
      this._busy = true;
      const btn = this.querySelector('[data-inr-cta]');
      const err = this.querySelector('[data-inr-error]');
      btn.disabled = true; btn.classList.add('loading'); btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      err.hidden = true;
      const solution = uid();
      const items = [];
      lines.forEach((l) => {
        const props = { ...(l.props || {}), _inr_losning: solution };
        const same = items.find((i) => i.id === l.variant.id && JSON.stringify(i.properties) === JSON.stringify(props));
        if (same) same.quantity += l.qty; else items.push({ id: l.variant.id, quantity: l.qty, properties: props });
      });
      try {
        const r = await fetch(`${this.dataset.cartAddUrl}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.description || data.message || '');
        window.location.href = this.dataset.cartUrl;
      } catch (e) {
        err.textContent = e.message ? `Lösningen kunde inte läggas i varukorgen: ${e.message}` : 'Lösningen kunde inte läggas i varukorgen. Försök igen.';
        err.hidden = false;
        this._busy = false; btn.classList.remove('loading'); btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        this.renderSummary();
      }
    }
  }
  customElements.define('inr-configurator', InrConfigurator);
})();
